import { ApplicationStatus } from 'api/btlApplicationForm/types';
import { ITEM_TITLE_KEYS } from 'components/CaseSidebar';
import type { OoCaseSidebarContext } from 'components/CaseSidebar/buildOoCaseSidebar';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { useCanAccessHppPages } from 'hooks';
import {
  useIsOoCaseNewSectionsEnabled,
  useIsOoCaseSolicitorsEnabled,
  useIsOoCaseSubmissionEnabled,
} from 'providers/PosthogProvider';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { CaseFinancingPage } from './Financing';
import { OoCaseSidebar } from './OoCaseSidebar';

export function OoApplicationCreatePage() {
  const [searchParams] = useSearchParams();
  const isNewSectionsEnabled = useIsOoCaseNewSectionsEnabled();
  const canAccessSolicitorsPage = useIsOoCaseSolicitorsEnabled();
  const canAccessSubmissionPages = useIsOoCaseSubmissionEnabled();
  const { canAccess: canAccessHppPages } = useCanAccessHppPages();

  const sidebarContext = useMemo<OoCaseSidebarContext>(
    () => ({
      status: ApplicationStatus.NEW,
      isNewSectionsEnabled,
      canAccessHppPages,
      canAccessSolicitorsPage,
      canEditDipAcceptedSections: false,
      canAccessSubmissionPages,
      isAffordabilityPassed: false,
      isCreateMode: true,
    }),
    [isNewSectionsEnabled, canAccessHppPages, canAccessSolicitorsPage, canAccessSubmissionPages],
  );

  const currentSection = searchParams.get('section') ?? CaseSidebarItemId.FINANCING;

  return (
    <div className='-mt-16 flex h-full min-h-0 bg-gray-100'>
      <div className='flex h-full min-h-0 shrink-0'>
        <OoCaseSidebar context={sidebarContext} currentSection={currentSection} />
      </div>
      <div className='flex min-h-0 flex-1 gap-8 p-6 pb-4 pl-8'>
        <div className='relative flex h-full grow flex-col pt-4'>
          <h2 className='mt-0'>
            <FormattedMessage id={ITEM_TITLE_KEYS[CaseSidebarItemId.FINANCING]} />
          </h2>
          <div id='form-scroll-container' className='custom-scrollbar mb-16 grow overflow-auto pb-4 pl-2 pr-4 pt-2'>
            <CaseFinancingPage isCreateMode sidebarContext={sidebarContext} canAccessHppPages={canAccessHppPages} />
          </div>
        </div>
      </div>
    </div>
  );
}
